module.exports = __webpack_public_path__ + "static/media/project-thumbnail15.3df23265.jpg";